import {fromJS, Map} from 'immutable'
import actionTypes from 'constants/submissionFormConstants'
import {preloadState, saveState} from 'lib/formStorage'

export const initialState = fromJS({
  data: {
    images: [],
    imagesLastError: null,
  },
  steps: {
    quick: {
      path: '/quick',
      accessible: true,
      completed: false,
      errors: {},
    },
    basics: {
      path: '/basics',
      accessible: true,
      completed: false,
      errors: {},
    },
    details: {
      path: '/details',
      accessible: false,
      completed: false,
      errors: {},
    },
    tickets: {
      path: '/tickets',
      accessible: false,
      completed: false,
      errors: {},
    },
    images: {
      path: '/images',
      accessible: false,
      completed: false,
      errors: {},
    },
    links: {
      path: '/links',
      accessible: false,
      completed: false,
      errors: {},
    },
    contact: {
      path: '/contact',
      accessible: false,
      completed: false,
      errors: {}
    },
    preview: {
      path: '/preview',
      accessible: false,
      completed: false,
      discovery_event: null,
      errors: {},
    }
  },
  isUploading: false,
  isLoading: false,

});

function isLoading(state, action) {
  switch(action.type) {
    case actionTypes.CREATE_DRAFT_REQUEST:
    case actionTypes.CREATE_EVENT_REQUEST:
    case actionTypes.SUBMISSION_FORM_VALIDATION_REQUEST:
      return true;
    case actionTypes.CREATE_DRAFT_SUCCESS:
    case actionTypes.CREATE_DRAFT_FAILURE:
    case actionTypes.CREATE_EVENT_SUCCESS:
    case actionTypes.CREATE_EVENT_FAILURE:
    case actionTypes.SUBMISSION_FORM_VALIDATION_SUCCESS:
      return false;
    default:
      return state;
  }
}

function handleValidationErrors(state, { stepId, errors }) {
  if(errors == 'Please fill at least one field'){
    return state;
  }

  const newState = state.setIn([stepId, 'errors'], fromJS(errors));
  saveState({ steps: newState.toJS() });
  return newState;
}

function completeStep(state, currentStepId) {
  const steps = state.keySeq();
  const nextStepName = steps.get(steps.indexOf(currentStepId) + 1);
  const newState = state.setIn([currentStepId, 'completed'], true)
    .setIn([nextStepName, 'accessible'], true);
  saveState({ steps: newState.toJS() });
  return newState;
}

function preparePreview(state, discovery_event) {
  return state.setIn(['preview', 'discovery_event'], discovery_event);
}

const formSteps = {
  full: ['basics', 'details', 'tickets', 'images', 'links', 'contact', 'preview'],
  quick: ['quick', 'preview'],
};

function switchForm(state, newForm) {
  return formSteps[newForm].length === state.size ? state :
    initialState.get('steps').filter((v, k) => (formSteps[newForm].includes(k)));
}

function steps(state, action) {
  switch(action.type) {
    case actionTypes.SUBMISSION_FORM_VALIDATION_SUCCESS:
      return handleValidationErrors(state, action.payload);
    case actionTypes.SUBMISSION_FORM_STEP_COMPLETED:
      return completeStep(state, action.payload.step);
    case actionTypes.SUBMISSION_FORM_SWITCH:
      return switchForm(state, action.payload.form);
    case actionTypes.SUBMISSION_FORM_PREPARE_PREVIEW:
      return preparePreview(state, action.payload.discovery_event);
    case actionTypes.SUBMISSION_FORM_CLEAR_PREVIEW:
      return preparePreview(state, null);
    default:
      return state;
  }
}

function isUploading(state, action) {
  switch(action.type) {
    case actionTypes.CREATE_IMAGE_REQUEST:
    case actionTypes.FETCH_IMAGE_REQUEST:
      return true;
    case actionTypes.CREATE_IMAGE_SUCCESS:
    case actionTypes.CREATE_IMAGE_FAILURE:
    case actionTypes.FETCH_IMAGE_SUCCESS:
    case actionTypes.FETCH_IMAGE_FAILURE:
      return false;
    default:
      return state;
  }
}

function filteredImages(images, id) {
  return images.filter((img) => img.get('id') !== id);
}

function data(state, action) {
  switch(action.type) {
    case actionTypes.FETCH_IMAGE_SUCCESS:
      return state.set('images', fromJS(action.payload));
    case actionTypes.CREATE_IMAGE_SUCCESS:
      return state.set('imagesLastError', null)
        .set('images', state.get('images')
          .push(fromJS(action.payload)));
    case actionTypes.CREATE_IMAGE_FAILURE:
      return state.set('imagesLastError', action.payload.details.image || action.payload.details.event_image);
    case actionTypes.REMOVE_IMAGE_SUCCESS:
      return state.set('images', filteredImages(state.get('images'), action.payload.id));
    default:
      return state;
  }
}

const submissionFormReducer = (state = initialState, action) => {
  return Map({
    steps: steps(state.get('steps'), action),
    data: data(state.get('data'), action),
    isLoading: isLoading(state.get('isLoading'), action),
    isUploading: isUploading(state.get('isUploading'), action),
  });
};

export default submissionFormReducer;



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/reducers/submissionFormReducer.js